module.exports = __webpack_public_path__ + "static/media/brain-min.2acd7a80.png";